import { render, staticRenderFns } from "./buyOrder.vue?vue&type=template&id=2437f042&scoped=true&"
import script from "./buyOrder.vue?vue&type=script&lang=js&"
export * from "./buyOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2437f042",
  null
  
)

export default component.exports